
import store from "@/store";
import { defineComponent } from "vue";
import { GlobalPagination } from "@/interfaces/panel/global-pagination.model";
import { NotVerifiedUser } from "@/interfaces/users/not-verified-user.model";
import ButtonComponent from "@/components/appComponents/Button.vue";
import CustomPaginationComponent from "@/components/appComponents/CustomPagination.vue";
import NotVerifiedUsersTableComponent from "@/components/usersComponents/NotVerifiedUsersTable.vue";
// import CheckUserIdentifyComponent from "@/components/appComponents/CheckUserIdentify.vue";

export default defineComponent({
    name: "NotVerifiedUsersPage",

    components: { ButtonComponent, NotVerifiedUsersTableComponent, CustomPaginationComponent },

    props: ["users"],

    computed: {
        getGlobalPagination(): GlobalPagination {
            return store.getters["panel/getGlobalPagination"];
        },

        getGlobalActivePage(): number {
            return store.getters["panel/getGlobalActivePage"];
        },

        getNotVerifiedUsers(): NotVerifiedUser[] {
            return store.getters["panel/getNotVerifiedUsers"];
        },
    },

    data() {
        return {
            showCreateNewPosDialog: false,
            showCheckUserDocument: false
        }
    },

    methods: {
        back(): void {
            this.$emit("back");
        },

        handelPagination(): void {
            store.dispatch("panel/getNotVerifiedUsersRequest", this.getGlobalActivePage);
        },

        handleUserIdentify() {
            console.log("show document!!!");
            this.showCheckUserDocument = true;
        },

        // closeCheckUserIdentify() {
        //     this.showCheckUserDocument = false;
        // }

        // submitCreateNewPos(editData: { model: string, serial: string, id: string }): void {
        //     const data = {
        //         mac: editData.id,
        //         modelname: editData.model,
        //         serial: editData.serial
        //     }
        //     store.dispatch("panel/sendCreateNewPos", data).then(() => {
        //         // updae show create new pos dialog
        //         this.showCreateNewPosDialog = false;
        //     });
        // }
    },

    mounted() {
        store.dispatch("panel/getNotVerifiedUsersRequest");
    }
})
